import { useEffect, useState } from "react";
import { Icon, type IconName } from "./Icon";

interface Note {
  id: number;
  text: string;
  icon: IconName;
}

let next = 1;
const listeners = new Set<(n: Note) => void>();

/** A short note at the top of a phone or iPad screen after an action: "Link copied", "Saved". */
export function toast(text: string, icon: IconName = "check"): void {
  const note = { id: next++, text, icon };
  for (const l of listeners) l(note);
}

const SHOW_MS = 2200;

/** Where the notes appear; the native frames draw one. */
export function Toaster() {
  const [note, setNote] = useState<Note | null>(null);
  const [on, setOn] = useState(false);

  useEffect(() => {
    const show = (n: Note) => {
      setNote(n);
      setOn(true);
    };
    listeners.add(show);
    return () => {
      listeners.delete(show);
    };
  }, []);

  useEffect(() => {
    if (!note) return;
    const hide = window.setTimeout(() => setOn(false), SHOW_MS);
    return () => window.clearTimeout(hide);
  }, [note]);

  if (!note) return null;
  return (
    <div className={on ? "po-toast on" : "po-toast"} role="status" aria-live="polite">
      <Icon name={note.icon} />
      <span>{note.text}</span>
    </div>
  );
}
